<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <br /><br />
          <div class="text-center">
            <img
              src="../../assets/img/mobileuser.png"
              style="max-width: 100%"
            />
          </div>

          <div class="card-custom-web">
            <br />
            <br />
            <CTabs>
              <CTab title="Invite A Friend" active>
                <h5 class="text-center mt-4">
                  <strong>Share your invite code</strong>
                </h5>
                <br />
                <h1 class="text-center mt-2 custom-code">
                  {{ user.codeSecret }}
                  <img src="../../assets/img/iconcopy.png" @click="copyLink" />
                  <span
                    style="font-size: 16px; color: #007cef"
                    class="text-muted small"
                    >{{ messagebtn }}</span
                  >
                </h1>
                <br />
                <div class="text-center m-0">
                  <label class="text-center"
                    >Get 10 credits when your friend sign up with Pickiddo using
                    your referral code
                  </label>
                  <CRow class="p-2">
                    <CCol sm="12">
                      <CButton
                        type="button"
                        class="btn-select-blue mt-5 text-center m-0"
                        @click="GoToApp"
                        id="whatsapp-mobile"
                        block
                        >Invite A Friend</CButton
                      >
                      <CButton
                        type="button"
                        class="btn-select-blue mt-5 text-center m-0"
                        @click="GoToWebs()"
                        id="whatsapp-desktop"
                        block
                        >Invite A Friend</CButton
                      >
                      <CButton
                        type="button"
                        class="btn-select-white"
                        block
                        style="width: 100% !important"
                        @click="GoToQr()"
                        >Show QR Code</CButton
                      >
                    </CCol>
                  </CRow>
                </div>
              </CTab>
              <CTab title="Friend's Invitation">
                <h5 class="mt-4 ml-3"><strong>Enter Referral Code</strong></h5>
                <CInput type="text" class="m-3" v-model="ReferCode"/>
                <br />
                <label class="ml-3"
                  >Get extra credit when you use your friends referral
                  code.</label
                >
                <CRow class="p-2">
                  <CCol sm="12">
                    <div class="text-center">
                      <CButton
                        type="button"
                        class="btn-select-blue mt-5"
                        style="width: 100% !important"
                        @click="SubmitInvitationCode"
                        >Enter Code</CButton
                      >
                    </div>
                  </CCol>
                </CRow>
              </CTab>
            </CTabs>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="header-top">Referral Code</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>
  
  <script>
  import Vue from "vue";
Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  data: function () {
    return {
      messagebtn: "",
      user: {},

      ReferCode: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
      this.SubmitCode();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GoBack() {
      this.$router.back();
    },
    GoToApp() {
      const myParamValue = this.extractString;
      const encodedParamValue = encodeURIComponent(myParamValue);

      window.open(
        `whatsapp://send?text=Check out this code referral ` +
          this.user.codeSecret
      );
    },
    GoToWebs() {
      var linkshares = this.linkShare;
      window.open(
        `https://web.whatsapp.com/send?text=Check out this code referral ` +
          this.user.codeSecret
      );
    },
    copyLink() {
      this.messagebtn = "Copied";
      navigator.clipboard.writeText(this.user.codeSecret);
    },
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.SubmitCode(this.user.id);
          }
        });
    },
    SubmitCode(id) {
      if (this.user.codeSecret == null) {
        const formData = new FormData();
        formData.append("userId", id);

        return this.$API
          .post(this.$InsertCode, formData)
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.GetInfoUser();
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
            }
          });
      }
    },
    GoToQr()
    {
      this.$router.push("QRCode");
    },
    SubmitInvitationCode() {
      if (this.user.codeSecret == this.ReferCode) {
        this.$dialog.alert("You are not allowed using same code with you").then(function () {});
      }
      else
      {
        const formData = new FormData();
        formData.append("UserId", this.user.id);
        formData.append("ReferCode1", this.ReferCode);

        return this.$API
          .post(this.$InsertInviteCode, formData)
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              if(response.data === 1)
              {
                this.GetInfoUser();
              this.$dialog.alert("Success Code").then(function () {});

              }
              else
              {
                this.$dialog.alert("Error Code").then(function () {});
              }
             
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
            }
          });
      }
    },
  },
};
</script>
  
  <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}
.ctabs {
  /* Add styles to the parent container if needed */
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  height: 100vh;
  margin-top: 50px;
  background: #f9f9f9;
  -webkit-box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.ctab {
  border-bottom: 2px solid transparent; /* Set a transparent bottom border for all tabs */
  padding-bottom: 10px; /* Adjust the padding as needed */
}

.ctab.active {
  border-color: #000; /* Set the bottom border color for the active tab */
}
@media only screen and (max-width: 768px) {
  #whatsapp-mobile {
    display: block;
    width: 100% !important;
  }
  #whatsapp-desktop {
    display: none;
  }
}
@media only screen and (min-width: 769px) {
  #whatsapp-mobile {
    display: none;
  }
  #whatsapp-desktop {
    display: block;
    width: 100% !important;
  }
}
</style>